// extracted by mini-css-extract-plugin
export default {"blur-on-hover":"Carousel_blur-on-hover__G59+m","image-container":"Carousel_image-container__6DztE","play-button":"Carousel_play-button__MD+Bp"};